const STORAGE_KEY = 'data-review-reviewed';

interface ReviewedProducts {
  [locale: string]: number[]; // variant IDs
}

const getReviewedProducts = (): ReviewedProducts => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

const saveReviewedProducts = (data: ReviewedProducts): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to save reviewed products:', error);
  }
};

export const markAsReviewed = (variantId: number, locale: string): void => {
  const data = getReviewedProducts();

  if (!data[locale]) {
    data[locale] = [];
  }

  if (!data[locale].includes(variantId)) {
    data[locale].push(variantId);
    saveReviewedProducts(data);
  }
};

export const markMultipleAsReviewed = (variantIds: number[], locale: string): void => {
  const data = getReviewedProducts();

  if (!data[locale]) {
    data[locale] = [];
  }

  const newIds = variantIds.filter((id) => !data[locale].includes(id));
  if (newIds.length > 0) {
    data[locale].push(...newIds);
    saveReviewedProducts(data);
  }
};

export const isReviewed = (variantId: number, locale: string): boolean => {
  const data = getReviewedProducts();
  return data[locale]?.includes(variantId) ?? false;
};

export const getReviewedVariantIds = (locale: string): number[] => {
  const data = getReviewedProducts();
  return data[locale] ?? [];
};

export const clearReviewedForLocale = (locale: string): void => {
  const data = getReviewedProducts();
  delete data[locale];
  saveReviewedProducts(data);
};

export const getReviewedCount = (locale: string): number => {
  const data = getReviewedProducts();
  return data[locale]?.length ?? 0;
};
